// http://{root}/about
import dynamic from 'next/dynamic'
import Image from 'next/image'
import Head from 'next/head'
export const metadata = {
	title: "About",
	description: "",
};
const Age = dynamic(() => import('@/components/age.js'), { ssr: false })
export default function About() {
	return (<>
		<Head>
			<title>{metadata.title}</title>
		</Head>
		<Age />
	</>)
}
